module.exports = __webpack_public_path__ + "img/N-icon.7a2904ca.svg";